
//操作成功后，的提示信息
function successToShow(msg = '保存成功', callback = function() {}) {
	
}

//操作失败的提示信息
function errorToShow(msg = '操作失败', callback = function() {}) {
	
}

export default {	
	
};
 